import React, { useState } from "react";

const TextField = (props) => {
    const {type, id, label, hint_text} = props;
    const [ input, setInput ] = useState("");

    return (
        <div>
            <label className="input-label" for={id}>{label}</label>
            <div className="textfield-container">
                <input onChange={event => setInput(event.target.value)} type={type} className={`textfield`} id={id} />
                <label for={id} className={input ? "trans" : ""} data-label={hint_text}></label>
            </div>
        </div>
    )
}

const HalfTextField = (props) => {
    const {type, id, label, hint_text} = props;
    const [ input, setInput ] = useState("");

    return (
        <div>
            <label className="input-label" for={id}>{label}</label>
            <div className="textfield-container">
                <input onChange={event => setInput(event.target.value)} type={type} className={`textfield half-size`} id={id}/>
                <label for={id} className={input ? "trans" : ""} data-label={hint_text}></label>
            </div>
        </div>
    )
}

const BigTextField = (props) => {
    const {type, id, label, hint_text} = props;
    const [ input, setInput ] = useState("");

    return (
        <div>
            <label className="input-label" for={id}>{label}</label>
            <div className="textfield-container big-size">
                <textarea 
                    rows={7} onChange={event => setInput(event.target.value)} 
                    type={type} 
                    className={`textfield`} 
                    id={id}>
                </textarea>
                <label for={id} className={input ? "trans" : ""} data-label={hint_text}></label>
            </div>
        </div>
    )
}

export {TextField, HalfTextField, BigTextField};